import { Button } from "../ui/Button";
import { applyUpdateNow, useAppUpdateStore } from "../../pwa/swUpdate";

/** Shown only when a new build is ready but reloading now would lose typed input. */
export function UpdateBanner() {
  const ready = useAppUpdateStore((s) => s.ready);
  if (!ready) return null;
  return (
    <div className="card row" role="status" data-testid="update-banner" style={{ alignItems: "center", justifyContent: "space-between", margin: "0.5rem" }}>
      <span>New version of Haul Sheet. Save what you&apos;re typing, then update.</span>
      <Button variant="primary" onClick={applyUpdateNow}>
        Update now
      </Button>
    </div>
  );
}
